import {GuestbookPost} from '../interfaces/entities/guestbook-post.interface';

export function activeVisibilitySensorForGuestbookPost(
  userId: string,
  {readByMe, user}: Pick<GuestbookPost, 'readByMe' | 'user'>
): boolean {
  return !readByMe && user?.id !== userId;
}
